import styled from "styled-components";
import { PALETTE } from "../commons/Commons.style";
import { BREAKPOINTS } from "../grid";

interface IPageHeaderProps {
  borderBottom?: boolean;
}

export const SlimPageHeaderContainerStyle = styled.section<IPageHeaderProps>`
  padding: 24px 0;

  ${({ borderBottom }) =>
    borderBottom && `border-bottom: thin solid ${PALETTE.LIGHT_GREY};`}

  @media only screen and (max-width: ${BREAKPOINTS.XL}px) {
    padding-bottom: 32px;
  }

  @media only screen and (max-width: ${BREAKPOINTS.LG}px) {
    margin: 0 -16px;
    padding: 24px 16px 32px;
  }

  @media only screen and (max-width: ${BREAKPOINTS.MD}px) {
    margin: 0 -8px;
    padding: 16px 8px 24px;
  }
`;

export const WidePageHeaderContainerStyle = styled.section<IPageHeaderProps>`
  padding: 24px 0 60px;

  ${({ borderBottom }) =>
    borderBottom && `border-bottom: thin solid ${PALETTE.LIGHT_GREY};`}

  @media only screen and (max-width: ${BREAKPOINTS.LG}px) {
    margin: 0 -16px;
    padding: 24px 16px 60px;
  }

  @media only screen and (max-width: ${BREAKPOINTS.MD}px) {
    margin: 0 -8px;
    padding: 16px 8px 24px;
  }
`;

export const PageHeaderStyle = styled.h1`
  font-weight: 300;
  font-size: 37px;
  line-height: 48px;

  @media only screen and (max-width: ${BREAKPOINTS.LG}px) {
    font-size: 32px;
    line-height: 40px;
  }

  @media only screen and (max-width: ${BREAKPOINTS.MD}px) {
    font-size: 27px;
    line-height: 35px;
  }
`;

export const PageHeaderDescriptionStyle = styled.p`
  font-size: 17px;
  line-height: 24px;
  margin-top: 16px;

  @media only screen and (max-width: ${BREAKPOINTS.MD}px) {
    margin-top: 12px;
  }
`;

export const PageHeaderAssetContainerStyle = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 40px;

  @media only screen and (max-width: ${BREAKPOINTS.XXL}px) {
    margin-top: 32px;
  }

  @media only screen and (max-width: ${BREAKPOINTS.LG}px) {
    margin-top: 40px;
  }

  @media only screen and (max-width: ${BREAKPOINTS.MD}px) {
    margin-top: 12px;
  }
`;
